import { isAutomationUser, isSyntheticUser, isCrawlerBot } from '../identity/skipIdentify.js';
import { getUserTraits, setUserTraits } from './identify.js';
import CustomerDataPlatformReporter, { validConfig } from '../reporters/customer-data-platform/CustomerDataPlatformReporter.js';
import CventAnalyticsReporter from '../reporters/cvent-analytics/CventAnalyticsReporter.js';
import { setReporter } from './reporters.js';
import { track } from './track.js';
import { updateUTMParametersFromUrl } from './utmActionProperties.js';
import LOG from '../logger.js';
import { enableDebugMode } from '../debug.js';
import { updateGlobalActionProperties } from './globalActionProperties.js';
import Flags from '../Flags.js';
function handleErrorDefault(error) {
    LOG.error(error);
}
const isJest = typeof jest !== 'undefined';
/**
 * Init function with extra internal configuration options
 */
export async function init(config, internalConfig) {
    if (!isJest && globalThis.CVENT_ANALYTICS_INITIALIZED) {
        if (typeof process !== 'undefined' && process.env?.CDF_MONOREPO !== 'true') {
            throw Error('@cvent/analytics has already been initialized. This could indicate a usage issue.');
        }
    }
    const promises = [];
    const { cventAnalytics, customerDataPlatform, defaultDestinations, pageTracking, onError = handleErrorDefault, onReady, debug, worker = true, detectBots = true } = config || {};
    const isDevMode = typeof process !== 'undefined' ? process.env.NODE_ENV === 'development' : false;
    const disabled = config?.disabled ?? isDevMode;
    // Disallow allow worker from be enabled when already disabled upstream (e.g. by the web bundle entrypoint)
    Flags.worker = Flags.worker && worker;
    if (debug) {
        enableDebugMode();
    }
    const isAutomation = isAutomationUser();
    const isSynthetic = isSyntheticUser();
    const isCrawler = isCrawlerBot();
    if (isAutomation || isSynthetic || (detectBots && isCrawler)) {
        LOG.debug('Skipping analytics initialization for bot', { isAutomation, isSynthetic, isCrawler });
        return;
    }
    const cventAnalyticsReporter = new CventAnalyticsReporter({
        ...cventAnalytics,
        defaultDestinations,
        onError,
        disabled
    });
    setReporter(cventAnalyticsReporter);
    if (validConfig(customerDataPlatform)) {
        const customerDataPlatformReporter = new CustomerDataPlatformReporter({
            ...customerDataPlatform,
            defaultDestinations,
            onError,
            disabled,
            importRudderAnalyticsClient: internalConfig?.importRudderAnalyticsClient
        });
        setReporter(customerDataPlatformReporter);
        promises.push(customerDataPlatformReporter.loadSDKs());
    }
    updateUTMParametersFromUrl();
    updateInitialUserTraits();
    if (config?.globalActionProperties) {
        updateGlobalActionProperties(config?.globalActionProperties);
    }
    if (pageTracking) {
        promises.push(import('../page-tracking.js').then(tracking => tracking.start({ track })));
    }
    await Promise.all(promises);
    globalThis.CVENT_ANALYTICS_INITIALIZED = true;
    if (onReady) {
        try {
            onReady();
        }
        catch (err) {
            onError(err instanceof Error ? err : new Error('Error while executing onReady()', { cause: err }));
        }
    }
}
/**
 * We need to send the UserGroup with every action
 * This handles applications that track actions before the user is identified.
 */
function updateInitialUserTraits() {
    const traits = getUserTraits();
    if (!traits?.group) {
        setUserTraits({ ...traits, group: 'unknown' });
    }
}
//# sourceMappingURL=init.js.map